/* TBC Motion : gestes du poker, en complément de tbc-scroll.js.
   1. Carte maîtresse : inclinaison 3D + reflet or au survol (souris uniquement).
   2. La Donne : les cartes produit arrivent face cachée puis se retournent.
   3. Le Jeton : un jeton or vole vers le panier après un ajout réussi.
   4. ALL IN : taper « allin » au clavier déclenche une pluie de jetons.
   Vanilla, sans dépendance. Coupé net si prefers-reduced-motion. */
(function () {
  'use strict';
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var VB = '81.53 -1.60 21.37 23.20';
  var SPADE = 'M92.2082 0C95.9513 5.65 101.292 6.7 101.292 10.75C101.292 14.8 96.7968 17.5589 92.9071 13.4C92.9071 18.2958 95.0993 19.9971 95.103 20H89.3135C89.3135 20 91.5095 18.3 91.5095 13.4C87.6198 17.5589 83.125 14.8 83.125 10.75C83.125 6.70001 88.4652 5.64998 92.2082 0Z';
  function spade(fill) { return '<svg viewBox="' + VB + '" aria-hidden="true"><path fill="' + fill + '" d="' + SPADE + '"/></svg>'; }
  function chipSvg(face, edge) {
    return '<svg viewBox="0 0 44 44" aria-hidden="true">' +
      '<circle cx="22" cy="22" r="21" fill="' + face + '" stroke="#C2A05A" stroke-width="1.5"/>' +
      '<circle cx="22" cy="22" r="18" fill="none" stroke="' + edge + '" stroke-width="5" stroke-dasharray="7 7.137"/>' +
      '<circle cx="22" cy="22" r="13" fill="none" stroke="#C2A05A" stroke-width="1"/>' +
      '<svg x="14.5" y="13.5" width="15" height="16.3" viewBox="' + VB + '"><path fill="#C2A05A" d="' + SPADE + '"/></svg></svg>';
  }

  /* ---------- 1. Carte maîtresse ---------- */
  var TILT = '.tbc26-pr__card .ph, product-card .card-gallery';
  function arm(el) {
    el.__tbcTilt = 1;
    el.classList.add('tbc-tilt', 'is-tilt');
    var g = document.createElement('span');
    g.className = 'tbc-glare';
    g.setAttribute('aria-hidden', 'true');
    el.appendChild(g);
    var raf = 0, px = .5, py = .5;
    function paint() {
      raf = 0;
      el.style.setProperty('--rx', ((.5 - py) * 9).toFixed(2) + 'deg');
      el.style.setProperty('--ry', ((px - .5) * 11).toFixed(2) + 'deg');
      el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    }
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      px = (e.clientX - r.left) / r.width; py = (e.clientY - r.top) / r.height;
      if (!raf) raf = requestAnimationFrame(paint);
    }, { passive: true });
    el.addEventListener('pointerenter', function () { el.classList.add('is-tilt'); });
    el.addEventListener('pointerleave', function () {
      el.classList.remove('is-tilt'); px = .5; py = .5;
      if (!raf) raf = requestAnimationFrame(paint);
    });
  }
  if (FINE) {
    document.addEventListener('pointerover', function (e) {
      var el = e.target.closest && e.target.closest(TILT);
      if (el && !el.__tbcTilt) arm(el);
    }, { passive: true });
  }

  /* ---------- 2. La Donne ---------- */
  var DEAL = '.product-grid__item, .tbc26-pr__card';
  var queue = [], dealing = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      queue.push(en.target);
    });
    if (!dealing) next();
  }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
  function next() {
    var it = queue.shift();
    if (!it) { dealing = false; return; }
    dealing = true;
    play(it);
    setTimeout(next, 90);
  }
  function prep(it) {
    if (it.__tbcDeal) return;
    it.__tbcDeal = 1;
    var r = it.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0) return;   // déjà à l'écran au chargement : on ne touche pas (LCP)
    it.classList.add('tbc-deal');
    var b = document.createElement('div');
    b.className = 'tbc-back';
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = spade('#C2A05A');
    it.appendChild(b);
    io.observe(it);
  }
  function play(it) {
    var r = it.getBoundingClientRect();
    var dx = (innerWidth / 2 - (r.left + r.width / 2)) * .45;
    it.style.setProperty('--dx', dx.toFixed(0) + 'px');
    it.style.setProperty('--dr', (dx > 0 ? -1 : 1) * (8 + Math.random() * 8) + 'deg');
    it.classList.add('is-dealt');
    setTimeout(function () {
      var b = it.querySelector(':scope > .tbc-back');
      if (b) b.remove();
      it.classList.remove('tbc-deal', 'is-dealt');
    }, 1100);
  }
  function scan(root) { (root || document).querySelectorAll(DEAL).forEach(prep); }
  // La grille d'accueil passe par la donne plutôt que par le fondu de tbc-scroll.js
  document.querySelectorAll('[data-tbc-stagger]').forEach(function (g) {
    if (g.querySelector('.tbc26-pr__card')) g.removeAttribute('data-tbc-stagger');
  });
  scan();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(DEAL)) prep(n); else if (n.querySelector) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- 3. Le Jeton ---------- */
  var lastBtn = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (b && !b.disabled) lastBtn = b;
  }, true);
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        var src = lastBtn;
        p.then(function (res) { if (res && res.ok) toss(src); }).catch(function () {});
      }
      return p;
    };
  }
  function cartIcon() {
    var els = document.querySelectorAll('.header-actions__cart-icon, cart-icon');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width && r.height) return { el: els[i], r: r };
    }
    return null;
  }
  function toss(src) {
    var dst = cartIcon();
    if (!dst) return;
    var a = src && src.isConnected ? src.getBoundingClientRect() : null;
    var x0 = a ? a.left + a.width / 2 : innerWidth / 2, y0 = a ? a.top + a.height / 2 : innerHeight * .7;
    var x1 = dst.r.left + dst.r.width / 2, y1 = dst.r.top + dst.r.height / 2;
    var cx = (x0 + x1) / 2 + (x1 - x0) * .15, cy = Math.min(y0, y1) - Math.max(120, Math.abs(x1 - x0) * .25);
    // Mise en scène lente : le jeton se soulève, tourne sur place, puis glisse vers le panier (2,1 s).
    var D = 2100, LIFT = .26, frames = [];
    var xl = x0, yl = y0 - 70;
    function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    for (var i = 0; i <= 10; i++) {          // 1. la mise : apparition, montée, un tour lent
      var t = i / 10, e = 1 - Math.pow(1 - t, 3);
      frames.push({ offset: LIFT * t, opacity: Math.min(1, t * 2.5),
        transform: 'translate(' + x0.toFixed(1) + 'px,' + (y0 + (yl - y0) * e).toFixed(1) + 'px) rotateY(' + (360 * e).toFixed(0) + 'deg) scale(' + (.5 + .85 * e).toFixed(3) + ')',
        filter: 'drop-shadow(0 ' + (8 + 16 * e).toFixed(1) + 'px ' + (14 + 14 * e).toFixed(1) + 'px rgba(21,18,11,.45)) drop-shadow(0 0 ' + (10 * e).toFixed(1) + 'px rgba(194,160,90,.75))' });
    }
    cy = Math.min(yl, y1) - Math.max(90, Math.abs(x1 - xl) * .22);
    cx = (xl + x1) / 2 + (x1 - xl) * .15;
    for (var j = 1, N = 30; j <= N; j++) {   // 2. le vol : arc ample, rotation qui ralentit à l'arrivée
      var tt = j / N, t2 = ease(tt), u = 1 - t2;
      var x = u * u * xl + 2 * u * t2 * cx + t2 * t2 * x1;
      var y = u * u * yl + 2 * u * t2 * cy + t2 * t2 * y1;
      var rot = 360 + 720 * (1 - Math.pow(1 - tt, 2));
      frames.push({ offset: LIFT + (1 - LIFT) * tt, opacity: 1,
        transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotateY(' + rot.toFixed(0) + 'deg) scale(' + (1.35 - .8 * t2).toFixed(3) + ')',
        filter: 'drop-shadow(0 ' + (24 - 16 * t2).toFixed(1) + 'px ' + (28 - 14 * t2).toFixed(1) + 'px rgba(21,18,11,.45)) drop-shadow(0 0 ' + (10 - 6 * t2).toFixed(1) + 'px rgba(194,160,90,.75))' });
    }
    var chip = mkChip(1);
    var ghosts = [mkChip(.32), mkChip(.14)];  // traînée dorée discrète pendant le vol
    ghosts.forEach(function (g, k) {
      g.animate(frames.map(function (f) { var o = Object.assign({}, f); o.opacity = f.offset < LIFT ? 0 : f.opacity * g._o; return o; }),
        { duration: D, delay: 55 * (k + 1), easing: 'linear', fill: 'forwards' }).onfinish = function () { g.remove(); };
    });
    var anim = chip.animate(frames, { duration: D, easing: 'linear', fill: 'forwards' });
    anim.onfinish = function () {
      chip.remove();
      dst.el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35) rotate(-12deg)' }, { transform: 'scale(.92) rotate(4deg)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }],
        { duration: 900, easing: 'cubic-bezier(.3,1.4,.5,1)' });
      [0, 180].forEach(function (delay, k) {    // 3. l'arrivée : deux ondes or
        var ring = document.createElement('div');
        ring.className = 'tbc-ring';
        ring.style.left = x1 + 'px'; ring.style.top = y1 + 'px';
        document.body.appendChild(ring);
        ring.animate([{ transform: 'scale(.4)', opacity: k ? .6 : .95 }, { transform: 'scale(' + (k ? 3.2 : 2.4) + ')', opacity: 0 }],
          { duration: 1000, delay: delay, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'both' }).onfinish = function () { ring.remove(); };
      });
    };
  }
  function mkChip(o) {
    var c = document.createElement('div');
    c.className = 'tbc-chip';
    c._o = o;
    c.style.opacity = 0;
    c.innerHTML = chipSvg('#15120B', '#F4F0E6');
    document.body.appendChild(c);
    return c;
  }

  /* ---------- 4. ALL IN ---------- */
  var buf = '', busy = false;
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (!e.key || e.key.length !== 1) return;
    buf = (buf + e.key.toLowerCase()).slice(-5);
    if (buf === 'allin' && !busy) allIn();
  });
  function chipImage(face, edge) {
    var img = new Image();
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(chipSvg(face, edge).replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" '));
    return img;
  }
  function allIn() {
    busy = true;
    var imgs = [chipImage('#15120B', '#F4F0E6'), chipImage('#F4F0E6', '#C2A05A'), chipImage('#C2A05A', '#15120B')];
    var cv = document.createElement('canvas'), dpr = Math.min(devicePixelRatio || 1, 2);
    cv.className = 'tbc-allin-cv';
    cv.width = innerWidth * dpr; cv.height = innerHeight * dpr;
    var ctx = cv.getContext('2d');
    ctx.scale(dpr, dpr);
    document.body.appendChild(cv);
    var bg = document.createElement('div');
    bg.className = 'tbc-allin-bg';
    document.body.appendChild(bg);
    bg.animate([{ opacity: 0 }, { opacity: 1, offset: .12 }, { opacity: 1, offset: .78 }, { opacity: 0 }], { duration: 3000, easing: 'ease', fill: 'forwards' });
    var title = document.createElement('div');
    title.className = 'tbc-allin-t';
    title.textContent = 'ALL IN';
    title.setAttribute('aria-hidden', 'true');
    document.body.appendChild(title);
    title.animate([
      { opacity: 0, transform: 'translate(-50%,-50%) scale(.7)', letterSpacing: '.6em', backgroundPosition: '100% 0' },
      { opacity: 1, transform: 'translate(-50%,-50%) scale(1)', letterSpacing: '.04em', offset: .25 },
      { opacity: 1, transform: 'translate(-50%,-50%) scale(1.04)', offset: .8 },
      { opacity: 0, transform: 'translate(-50%,-50%) scale(1.1)', backgroundPosition: '0 0' }
    ], { duration: 2600, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' });
    var W = innerWidth, H = innerHeight, chips = [], n = W < 700 ? 55 : 90;
    for (var i = 0; i < n; i++) {
      chips.push({ x: Math.random() * W, y: -60 - Math.random() * H * .9, vy: 2 + Math.random() * 3, vx: (Math.random() - .5) * 1.6,
        sz: 26 + Math.random() * 26, ph: Math.random() * 6.28, sp: .08 + Math.random() * .14, im: imgs[i % 3] });
    }
    var t0 = performance.now();
    (function frame(now) {
      var el = now - t0;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = el > 2600 ? Math.max(0, 1 - (el - 2600) / 500) : 1;
      chips.forEach(function (c) {
        c.vy += .14; c.y += c.vy; c.x += c.vx; c.ph += c.sp;
        if (c.y > H - c.sz / 2 && c.vy > 0) { c.y = H - c.sz / 2; c.vy *= -.38; c.vx *= .7; }
        var sx = Math.cos(c.ph);
        ctx.save(); ctx.translate(c.x, c.y); ctx.scale(Math.abs(sx) < .08 ? .08 : sx, 1);
        if (c.im.complete) ctx.drawImage(c.im, -c.sz / 2, -c.sz / 2, c.sz, c.sz);
        ctx.restore();
      });
      if (el < 3100) requestAnimationFrame(frame);
      else { cv.remove(); title.remove(); bg.remove(); busy = false; }
    })(t0);
  }
  /* ---------- 5. Recto-verso : la photo face se retourne sur le dos ---------- */
  var RV_BACK = /\b(dos|back|espalda|costas|verso)\b/i, RV_WORN = /studio|port[ée]|worn|vestid|usad/i;
  var RV_TXT = { fr: ['Voir le dos', 'Voir la face'], en: ['See the back', 'See the front'], es: ['Ver la espalda', 'Ver el frente'], pt: ['Ver as costas', 'Ver a frente'] };
  var rvLang = (document.documentElement.lang || 'fr').slice(0, 2), rvT = RV_TXT[rvLang] || RV_TXT.fr;
  function shown(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }
  function initRV() {
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var conts = [].filter.call(g.querySelectorAll('.product-media-container'), function (c) { return shown(c) && c.querySelector('img.product-media__image'); });
    var front = null, back = null, backWorn = null;
    conts.forEach(function (c) {
      var alt = c.querySelector('img.product-media__image').alt || '';
      if (!RV_BACK.test(alt)) { if (!front) front = c; }
      else if (!RV_WORN.test(alt)) { if (!back) back = c; }
      else if (!backWorn) backWorn = c;
    });
    back = back || backWorn;
    if (!front || !back) return;
    var media = front.querySelector('.product-media');
    if (!media) return;
    var fi = front.querySelector('img.product-media__image'), bi = back.querySelector('img.product-media__image');
    if (media.__tbcRV) {   // coloris changé : on garde la carte, on met le bon dos
      var cur = media.__tbcRV, src = bi.currentSrc || bi.src;
      if (cur.src !== src) cur.src = src;
      return;
    }
    var face = document.createElement('div');
    face.className = 'tbc-rv__back';
    face.setAttribute('aria-hidden', 'true');
    var im = document.createElement('img');
    im.src = bi.currentSrc || bi.src; im.alt = ''; im.decoding = 'async';
    im.style.objectFit = getComputedStyle(fi).objectFit || 'cover';
    face.appendChild(im);
    media.__tbcRV = im;
    media.classList.add('tbc-rv');
    media.appendChild(face);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tbc-rv__btn';
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.3-5.6M20 4v4h-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + rvT[0] + '</span>';
    front.classList.add('tbc-rv-host');
    front.appendChild(btn);
    var busy = false;
    function flip() {
      if (busy) return; busy = true;
      var on = !media.classList.contains('is-back');
      media.animate([{ transform: 'perspective(1400px) rotateY(0deg)' }, { transform: 'perspective(1400px) rotateY(90deg)' }], { duration: 260, easing: 'cubic-bezier(.55,0,.9,.45)' }).onfinish = function () {
        media.classList.toggle('is-back', on);
        btn.querySelector('span').textContent = rvT[on ? 1 : 0];
        media.animate([{ transform: 'perspective(1400px) rotateY(-90deg)' }, { transform: 'perspective(1400px) rotateY(0deg)' }], { duration: 420, easing: 'cubic-bezier(.15,.85,.3,1.15)' }).onfinish = function () { busy = false; };
      };
    }
    btn.__flip = flip;
    // invitation discrète : la carte se soulève une fois quand elle apparaît
    var pio = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      pio.disconnect();
      setTimeout(function () {
        if (!busy) media.animate([{ transform: 'perspective(1400px) rotateY(0)' }, { transform: 'perspective(1400px) rotateY(-16deg)', offset: .45 }, { transform: 'perspective(1400px) rotateY(0)' }], { duration: 1100, easing: 'cubic-bezier(.3,.7,.3,1)' });
      }, 900);
    }, { threshold: .6 });
    pio.observe(media);
  }
  if (document.querySelector('media-gallery')) {
    // Le thème délègue ses clics (zoom de galerie) en capture sur document : on passe avant, au niveau de window.
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click'].forEach(function (ev) {
      window.addEventListener(ev, function (e) {
        var b = e.target && e.target.closest && e.target.closest('.tbc-rv__btn');
        if (!b) return;
        e.stopPropagation();
        if (ev === 'click') { e.preventDefault(); if (b.__flip) b.__flip(); }
      }, { capture: true, passive: ev !== 'click' });
    });
    initRV();
    window.addEventListener('load', initRV);
    var rvT0 = 0;
    new MutationObserver(function () { clearTimeout(rvT0); rvT0 = setTimeout(initRV, 250); })
      .observe(document.querySelector('media-gallery').parentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
  }
})();
